import axios from "axios";

const server = process.env.REACT_APP_ENV === 'PROD' ?
  "https://tech-start-prod-srv.azurewebsites.net/" : "https://tech-start-qa-srv.azurewebsites.net/";
// const server = "http://localhost:5001/";  //for local back-end

const header = () => {
  return {
    headers: {
      Authorization: localStorage.getItem('token')
    }
  }
}

export const get = (url) => axios.get(server + url, header());

export const post = (url, payload) => axios.post(server + url, payload, header());

export const patch = (url, payload) => axios.patch(server + url, payload, header());

export const remove = (url) => axios.delete(server + url, header());

